import Vue from 'vue';

Vue.component('quiz-video-player', {
  props: ['video', 'options'],
  methods: {
    toggleControls: function (ev) {
      if (ev.type == 'mouseover') {
        this.showControls = true;
      } else if (ev.type == 'mouseout') {
        this.showControls = false;
      }
    },
    videoPlay: function () {
      this.showOverlay = false;
    },
    videoPause: function () {
      this.showOverlay = true;
    },
    play: function () {
      this.$refs.video.play().catch(function (err) {
        console.log(err);
      });
    },
    loadingSucceeded: function () {
      this.showOverlay = true;
    },
    loadingFailed: function (ev) {
      this.showProcessing = true;
    },
  },
  mounted: function () {
    this.encodeEventListener = (ev, data) => {
      if (this.video.data == data.uuid) {
        this.video.data = data.uuid;
        this.video.preview = data.poster;
        this.showProcessing = false;
        this.$refs.video.load();
      }
    };
    $(document).on('video.encoded', this.encodeEventListener);
  },
  beforeDestroy: function () {
    $(document).off('video.encoded', this.encodeEventListener);
    this.encodeEventListener = null;
  },
  computed: {
    mp4: function () {
      let fileservice_url = this.options.upload.url.slice(0, -1);
      return `${fileservice_url}/` + this.video.data + '.mp4';
    },
  },
  data: function () {
    return {
      showControls: false,
      showOverlay: false,
      showProcessing: false,
    };
  },
  template: `
    <div v-bind:style="{ position: 'relative', 'borderRadius': '8px', height: '100%'}">
      <video ref="video" width="100%" v-on:error="loadingFailed" v-on:loadeddata="loadingSucceeded" v-bind:poster="video.preview" v-on:mouseover="toggleControls" v-on:play="videoPlay" v-on:pause="videoPause" v-on:mouseout="toggleControls" v-bind:controls="showControls">
        <source v-bind:src="mp4" type="video/mp4">
      </video>    
      <div tabindex="0" class="lp--quizWidgetVideoPlayOverlay" v-if="showOverlay && !showProcessing" v-on:click="play" v-on:keyup.enter="play"></div>
      <div class="lp--quizWidgetVideoProcessingOverlay" v-if="showProcessing"></div>
    </div> 
  `,
});
